import { render } from "./aboutMeInCodeComponent.vue?vue&type=template&id=3582cc98&scoped=true&ts=true"
import script from "./aboutMeInCodeComponent.vue?vue&type=script&lang=ts"
export * from "./aboutMeInCodeComponent.vue?vue&type=script&lang=ts"

import "./aboutMeInCodeComponent.vue?vue&type=style&index=0&id=3582cc98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3582cc98"]])

export default __exports__